export const stripHtml = (string) => {
  if (string) {
    string = string.replace(/(<([^>]+)>)/g, '')

    return string
  }
}
